import {
  Text,
  Flex,
  Textarea,
  type FlexProps,
  type TextareaProps,
} from '@mantine/core';
import classes from './FormTextarea.module.scss';

interface FormTextareaProps extends TextareaProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
}

export const FormTextarea = ({
  title,
  description,
  placeholder,
  containerProps,
  ...props
}: FormTextareaProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>
      <Textarea
        className={classes.rightColumn}
        classNames={{ input: classes.input }}
        variant='filled'
        placeholder={placeholder}
        autosize
        minRows={3}
        {...props}
      />
    </Flex>
  );
};
